// material-ui
import logo from "../assets/logos/vertical-colorful.png";

const NavbarLogo = () => {
  return <img src={logo} width={70} />;
};

export default NavbarLogo;
